/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_View_ChartInputs */



/**
* | output |
* | --- |
* | "Chart" |
*
* @param {Usage_View_ChartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_view_chart = /** @type {((inputs?: Usage_View_ChartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_View_ChartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Graphique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Diagramm")
	if (locale === "it") return /** @type {LocalizedString} */ ("Grafico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Диаграмма")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuadro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("图表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チャート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चार्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gráfico")
	return /** @type {LocalizedString} */ ("Chart")
});